(function () {
  'use strict';

  function initSlider(root) {
    var track = root.querySelector('[data-fqs-slider]');
    if (!track) return;

    var slides = Array.prototype.slice.call(track.querySelectorAll('[data-fqs-slide]'));
    if (slides.length < 2) return;

    var prevBtn = track.querySelector('[data-fqs-prev]');
    var nextBtn = track.querySelector('[data-fqs-next]');
    var dotsWrap = root.querySelector('[data-fqs-dots]');
    var dots = Array.prototype.slice.call(root.querySelectorAll('[data-fqs-dot]'));

    // ----- Settings coming from data attributes (true/false) -----
    var autoplay = root.getAttribute('data-fqs-autoplay') === 'true';
    var showArrows = root.getAttribute('data-fqs-arrows') !== 'false'; // default true unless explicitly "false"
    var showDots = root.getAttribute('data-fqs-dots') !== 'false'; // default true unless explicitly "false"
    var autoplaySpeed = parseInt(root.getAttribute('data-fqs-autoplay-speed'), 10);
    if (isNaN(autoplaySpeed) || autoplaySpeed <= 0) autoplaySpeed = 4000;

    var current = 0;
    var total = slides.length;
    var autoplayTimer = null;

    // ----- Arrows: hide if disabled -----
    if (!showArrows) {
      if (prevBtn) prevBtn.style.display = 'none';
      if (nextBtn) nextBtn.style.display = 'none';
    }

    // ----- Dots: hide if disabled -----
    if (!showDots && dotsWrap) {
      dotsWrap.style.display = 'none';
    }

    function goTo(index) {
      index = (index + total) % total;

      slides[current].classList.remove('is-active');
      if (dots[current]) dots[current].classList.remove('is-active');

      current = index;

      slides[current].classList.add('is-active');
      if (dots[current]) dots[current].classList.add('is-active');
    }

    function nextSlide() {
      goTo(current + 1);
    }

    // ----- Autoplay -----
    function startAutoplay() {
      if (!autoplay) return;
      stopAutoplay();
      autoplayTimer = setInterval(nextSlide, autoplaySpeed);
    }

    function stopAutoplay() {
      if (autoplayTimer) {
        clearInterval(autoplayTimer);
        autoplayTimer = null;
      }
    }

    function restartAutoplay() {
      if (!autoplay) return;
      stopAutoplay();
      startAutoplay();
    }

    if (prevBtn && showArrows) {
      prevBtn.addEventListener('click', function () {
        goTo(current - 1);
        restartAutoplay();
      });
    }

    if (nextBtn && showArrows) {
      nextBtn.addEventListener('click', function () {
        goTo(current + 1);
        restartAutoplay();
      });
    }

    dots.forEach(function (dot) {
      dot.addEventListener('click', function () {
        var idx = parseInt(dot.getAttribute('data-index'), 10);
        if (!isNaN(idx)) {
          goTo(idx);
          restartAutoplay();
        }
      });
    });

    // Basic swipe support for touch devices
    var touchStartX = 0;
    var touchEndX = 0;

    track.addEventListener('touchstart', function (e) {
      touchStartX = e.changedTouches[0].screenX;
    }, { passive: true });

    track.addEventListener('touchend', function (e) {
      touchEndX = e.changedTouches[0].screenX;
      var diff = touchStartX - touchEndX;
      if (Math.abs(diff) > 40) {
        if (diff > 0) {
          goTo(current + 1);
        } else {
          goTo(current - 1);
        }
        restartAutoplay();
      }
    }, { passive: true });

    // Pause autoplay while user hovers/interacts, resume on leave
    if (autoplay) {
      root.addEventListener('mouseenter', stopAutoplay);
      root.addEventListener('mouseleave', startAutoplay);
      startAutoplay();
    }
  }

  function initAll() {
    var sections = document.querySelectorAll('[data-fqs-section]');
    sections.forEach(initSlider);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initAll);
  } else {
    initAll();
  }

  // Re-init when a section is added/reloaded in the theme editor
  document.addEventListener('shopify:section:load', function (event) {
    initSlider(event.target);
  });
})();